import { getCookieAction } from '@/actions/cookies/get-cookie.action'
import { getAccessTokenAction } from '@/api/actions/get-access-token.action'
import { log } from '@/lib'

export const secureFetch = async (url: string, options?: RequestInit) => {
  try {
    const [tokenCookie, token] = await Promise.all([getCookieAction('accessToken'), getAccessTokenAction()])
    const accessToken = token || tokenCookie

    if (!accessToken) {
      log.error('secureFetch:: Access token is not available', url)
      throw new Error('secureFetch:: Access token is not available')
    }

    const headers = new Headers(options?.headers ?? {})
    if (accessToken) headers.set('token', `${accessToken}`)

    // Only set Content-Type if it's not FormData and not already set
    if (!(options?.body instanceof FormData) && !headers.has('Content-Type')) {
      headers.set('Content-Type', 'application/json')
    }

    const response = await fetch(url, {
      cache: 'no-store',
      ...options,
      headers,
    })

    if (response.status === 401 || response.status === 403) {
      throw new Error('Unauthorized')
    }

    if (!response.ok) {
      let errorBody = ''
      try {
        errorBody = await response.text()
      } catch {
        errorBody = 'Unable to parse error response'
      }
      throw new Error(`Error: ${response.statusText} ${errorBody}`)
    }

    return response
  } catch (error) {
    log.error('secureFetch:: Error fetching data:', error)
    throw error
  }
}
